const getUpdatedItemsToDisplay = ({
  parentSchema,
  parentEntityData,
  itemsToDisplay = [],
  inheritedFilters = []
}) => {
  const idProp = inheritedFilters.find(filter => filter.indexOf('id/') === 0);
  if (!idProp || !parentSchema || !parentEntityData) return itemsToDisplay;
  const {
    properties
  } = parentSchema;
  const [, entityKey] = idProp.split('/');
  if (!properties || !entityKey) return itemsToDisplay;
  const queryValue = Object.keys(properties).find(propKey => properties[propKey] && properties[propKey].relation && properties[propKey].relation.entityIdentifier === entityKey);
  const parentValues = parentEntityData[queryValue];
  if (!parentValues) return itemsToDisplay;
  const updatedItemsToDisplay = [...itemsToDisplay];
  if (Array.isArray(parentValues)) {
    parentValues.forEach(value => {
      updatedItemsToDisplay.push({
        displayItems: [value]
      });
    });
  } else {
    updatedItemsToDisplay.push({
      displayItems: [parentValues]
    });
  }
  return updatedItemsToDisplay;
};
export default getUpdatedItemsToDisplay;
//# sourceMappingURL=get-updated-items-to-display.js.map